import {I18n} from '@aws-amplify/core';
import {SimplePageHeader} from '@flexinet/ui-components';

import config from '../config';

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader title={I18n.get(config.titles.plural)}/>
    );
};
